export default __webpack_public_path__ + "static/media/aditya.f4955f3c.jpeg";